import {
  POLICIES_AND_MODS_POLICIES_FILTER_RESET,
  POLICIES_AND_MODS_EX_MODS_FILTER_RESET,
  POLICIES_AND_MODS_FILTER_UPDATED,
  POLICIES_AND_MODS_FILTER_RESET,
  POLICIES_AND_MODS_TOGGLE_FILTER,
} from '../actions/PcPoliciesAndModsActions';

// This is our apps initial state
// Since the initial state should never change, it is wrapped in a function to prevent unintended modification.
const getInitialState = () => {
  return {
    pcPoliciesFilterExpanded: false,
    // PC Policies
    policiesPolicyTypeFilter: [],
    policiesBrokerFilter: [],
    policiesStateFilter: [],
    policiesCarrierFilter: [],
    policiesPolicyNumberFilter: [],
    // Ex Mods
    pcExModsFilterExpanded: false,
    exModsStateFilter: [],
    exModsBureauNumberFilter: [],
  };
};

function PcPoliciesAndModsState(state = getInitialState(), action) {
  switch (action.type) {
    case POLICIES_AND_MODS_FILTER_UPDATED:
      const { selectedValues, name } = action;
      const newState = { ...state };
      newState[name] = selectedValues;
      return {
        ...newState,
      };
    case POLICIES_AND_MODS_POLICIES_FILTER_RESET:
      return {
        ...state,
        policiesPolicyTypeFilter: [],
        policiesBrokerFilter: [],
        policiesStateFilter: [],
        policiesCarrierFilter: [],
        policiesPolicyNumberFilter: [],
      };
    case POLICIES_AND_MODS_EX_MODS_FILTER_RESET:
      return {
        ...state,
        exModsStateFilter: [],
        exModsBureauNumberFilter: [],
      };
    case POLICIES_AND_MODS_FILTER_RESET:
      return {
        ...state,
        policiesPolicyTypeFilter: [],
        policiesBrokerFilter: [],
        policiesStateFilter: [],
        policiesCarrierFilter: [],
        policiesPolicyNumberFilter: [],
        exModsStateFilter: [],
        exModsBureauNumberFilter: [],
      };
    case POLICIES_AND_MODS_TOGGLE_FILTER:
      const { expanded, filterName } = action;

      if (!filterName) {
        return {
          ...state,
        };
      }
      const newFilterState = { ...state };
      newFilterState[filterName] = expanded;
      return {
        ...newFilterState,
      };
    default:
      return state;
  }
}

export default PcPoliciesAndModsState;
